import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { currencyFormatter } from 'utils/formatter';
import styles from './SummaryAdjustment.css';

class SummaryAdjustment extends React.Component {
  render() {
    const { search } = this.props;

    return (
      <div className={`${styles['summary-adjustment']} visible-md visible-lg`}>
        {search && search.namespace === 'items'
          ? this._renderSummaryInvAdjustment()
          : this._renderSummaryIngInvAdjustment()}
      </div>
    );
  }

  _renderSummaryInvAdjustment = () => {
    const { summaryAdjustment } = this.props;
    const {
      totalCount,
      totalExpense,
      totalIncome,
      totalItems,
    } = summaryAdjustment;

    return (
      <div>
        <div className="row">
          <div className="col-xs-2">
            <div className={styles.amount}>{totalCount}</div>
            <div className={styles.title}>ADJUSTMENTS</div>
          </div>
          <div className="col-xs-2">
            <div className={styles.amount}>{totalItems || 0}</div>
            <div className={styles.title}>ITEM ADJUSTED</div>
          </div>
          <div className="col-xs-4">
            <div className={styles.amount}>
              {currencyFormatter(totalExpense)}
            </div>
            <div className={styles.title}>TOTAL ADJUSTMENT EXPENSE</div>
          </div>
          <div className="col-xs-4">
            <div className={styles.amount}>
              {currencyFormatter(totalIncome)}
            </div>
            <div className={styles.title}>TOTAL ADJUSTMENT INCOME</div>
          </div>
        </div>
      </div>
    );
  };

  _renderSummaryIngInvAdjustment = () => {
    const { summaryIngredientAdjustment } = this.props;
    const {
      totalCount,
      totalExpense,
      totalIncome,
      totalIngredients,
    } = summaryIngredientAdjustment;
    return (
      <div>
        <div className="row">
          <div className="col-xs-2">
            <div className={styles.amount}>{totalCount}</div>
            <div className={styles.title}>ADJUSTMENTS</div>
          </div>
          <div className="col-xs-2">
            <div className={styles.amount}>{totalIngredients || 0}</div>
            <div className={styles.title}>INGREDIENT ADJUSTED</div>
          </div>
          <div className="col-xs-4">
            <div className={styles.amount}>
              {currencyFormatter(totalExpense)}
            </div>
            <div className={styles.title}>TOTAL ADJUSTMENT EXPENSE</div>
          </div>
          <div className="col-xs-4">
            <div className={styles.amount}>
              {currencyFormatter(totalIncome)}
            </div>
            <div className={styles.title}>TOTAL ADJUSTMENT INCOME</div>
          </div>
        </div>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const {
    summaryAdjustment,
    summaryIngredientAdjustment,
  } = state.inventory.adjustment;
  return {
    search: getFormValues('search')(state),
    summaryAdjustment,
    summaryIngredientAdjustment,
  };
}

export default connect(mapStateToProps)(SummaryAdjustment);
